import {curry, identity, unary, pipe, isFunction} from './function'

export const head = arr => (isFunction(arr && arr.slice) ? arr[0]: undefined)

export const last = arr =>
  (isFunction(arr && arr.slice) ? arr[arr.length - 1]: undefined)

export const join = curry((joiner, arr) => (isFunction(arr && arr.join) ? arr.join(joiner): ''))

export const map = curry((fn, arr) => (isFunction(arr && arr.map) ? arr.map(unary(fn)): []))

export const filter = curry((fn, arr) => (isFunction(arr && arr.filter) ? arr.filter(unary(fn)): []))

export const compact = filter(pipe(identity, Boolean))

export const take = curry((n, arr) =>
  (isFunction(arr && arr.slice) ? (n < 0 ? arr.slice(n): arr.slice(0, n)): []))

export const range = curry((min, max) =>
  Array(max - min).fill().map((_, idx) => min + idx))

export const compactMap = curry((fn, arr) =>
  (isFunction(arr && arr.reduce)
    ? arr.reduce((out, val) => {
      const fnResult = fn(val)
      if (fnResult) out.push(fnResult)
      return out
    }, [])
    : []))

export const flatMap = curry((fn, arr) =>
  (isFunction(arr && arr.reduce)
    ? arr.reduce((out, val) => out.concat(fn(val)), [])
    : []))

export const compareArrays = (arr1, arr2) => {
  if (!arr1 || !arr2) return false
  if (arr1.length !== arr2.length) return false
  
  for (let i = 0, l = arr1.length; i < l; i++) {
    // Check if we have nested arrays
    if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!compareArrays(arr1[i], arr2[i])) return false
    } else if (arr1[i] !== arr2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false
    }
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/array.js